/*
  Sisters Moto: keeps the #dropdown sort menu (third-party YMM results) positioned
  under its button. Moved verbatim from an inline <script> in layout/theme.liquid;
  loaded with defer from the same place, still runs on DOMContentLoaded.
*/
document.addEventListener('DOMContentLoaded', function () {
  var wrapper = document.getElementById('dropdown');
  if (!wrapper) return;
  var menu = wrapper.querySelector('ul.dropdown');
  if (!menu) return;

  // Force hide immediately
  menu.style.setProperty('display', 'none', 'important');

  // Watch the ul's style attribute — when plugin shows it, reposition it
  var styleObserver = new MutationObserver(function () {
    if (menu.style.display === 'none') return;

    // Plugin just showed it — measure and reposition
    menu.style.setProperty('visibility', 'hidden', 'important');
    menu.style.setProperty('position', 'fixed', 'important');
    menu.style.setProperty('z-index', '99999', 'important');
    menu.style.setProperty('background', '#fff', 'important');
    menu.style.setProperty('border', '1px solid #ddd', 'important');
    menu.style.setProperty('border-radius', '4px', 'important');
    menu.style.setProperty('list-style', 'none', 'important');
    menu.style.setProperty('padding', '4px 0', 'important');
    menu.style.setProperty('margin', '0', 'important');
    menu.style.setProperty('min-width', '180px', 'important');
    menu.style.setProperty('box-shadow', '0 4px 12px rgba(0,0,0,0.12)', 'important');

    var rect  = wrapper.getBoundingClientRect();
    var mw    = menu.offsetWidth || 180;
    menu.style.setProperty('top',  (rect.bottom + 4) + 'px', 'important');
    menu.style.setProperty('left', (rect.right - mw) + 'px',  'important');
    menu.style.removeProperty('visibility');
  });

  styleObserver.observe(menu, { attributes: true, attributeFilter: ['style'] });

  // Keep position on scroll/resize
  window.addEventListener('scroll', function () {
    if (menu.style.display !== 'none') {
      var rect = wrapper.getBoundingClientRect();
      var mw   = menu.offsetWidth || 180;
      menu.style.setProperty('top',  (rect.bottom + 4) + 'px', 'important');
      menu.style.setProperty('left', (rect.right - mw) + 'px',  'important');
    }
  }, true);

  window.addEventListener('resize', function () {
    if (menu.style.display !== 'none') {
      var rect = wrapper.getBoundingClientRect();
      var mw   = menu.offsetWidth || 180;
      menu.style.setProperty('top',  (rect.bottom + 4) + 'px', 'important');
      menu.style.setProperty('left', (rect.right - mw) + 'px',  'important');
    }
  });
});

/* Accessibility: Google's merchant rating badge (injected by Google, not the theme)
   arrives as an untitled iframe. Give it an accessible name when it appears. */
(function () {
  function label() {
    var f = document.getElementById('merchantwidgetiframe');
    if (f && !f.getAttribute('title')) f.setAttribute('title', 'Google Customer Reviews store rating');
    return !!f;
  }
  if (label()) return;
  var mo = new MutationObserver(function () { if (label()) mo.disconnect(); });
  mo.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(function () { mo.disconnect(); }, 30000);
})();
